export default __webpack_public_path__ + "static/media/mouth.771e629adc7aaea28f5af47140c4491c.png";